import React from 'react';
import { TotalRevenueKPI, TotalInvoicesKPI, CreditUsageRateKPI, CreditToRevenueKPI } from './kpis';

interface KPIsSectionProps {
  branchId?: number;
  timeRange?: any;
  onError?: (error: Error) => void;
  showLoading?: boolean;
  compact?: boolean;
}

const KPIsSection: React.FC<KPIsSectionProps> = ({
  branchId,
  timeRange,
  onError,
  showLoading = true,
  compact = false
}) => {
  return (
    <div className={`grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 ${compact ? 'md:gap-4' : 'md:gap-6'} animate-enter-up`}>
      <TotalRevenueKPI
        branchId={branchId}
        timeRange={timeRange}
        onError={onError}
        showLoading={showLoading}
        compact={compact}
      />
      
      <TotalInvoicesKPI
        branchId={branchId}
        timeRange={timeRange}
        onError={onError}
        showLoading={showLoading}
        compact={compact}
      />
      
      <CreditUsageRateKPI
        branchId={branchId}
        timeRange={timeRange}
        onError={onError}
        showLoading={showLoading}
        compact={compact}
      />
      
      <CreditToRevenueKPI
        branchId={branchId}
        timeRange={timeRange}
        onError={onError}
        showLoading={showLoading}
        compact={compact}
      />
    </div>
  );
};

export default KPIsSection;